import { RegistrationState, RegistrationAction, ActionType } from './types'

export const initialState: RegistrationState = {
  data: null,
  types: null,
  analytics: null,
  divisions: [],
  loading: {
    fetch: true,
    analytics: false,
    types: false,
    statusUpdate: new Set<string>(),
  },
  error: null,
  scheduleId: '',
  isPlayerRegistrationEnabled: false,
  isTeamRegistrationEnabled: false,
  showWaiver: false,
  currency: { id: '1', name: 'CAD', name_full: null, abbreviation: null },
  isRegistrationEmpty: false,
}

export const registrationReducer = (
  state: RegistrationState,
  action: RegistrationAction
): RegistrationState => {
  switch (action.type) {
    case ActionType.SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetch: action.payload,
        },
      }

    case ActionType.SET_LOADING_ANALYTICS:
      return {
        ...state,
        loading: {
          ...state.loading,
          analytics: action.payload,
        },
      }

    case ActionType.SET_LOADING_TYPES:
      return {
        ...state,
        loading: {
          ...state.loading,
          types: action.payload,
        },
      }

    case ActionType.SET_STATUS_UPDATE_LOADING: {
      const newStatusUpdate = new Set(state.loading.statusUpdate)
      if (action.payload.loading) {
        newStatusUpdate.add(action.payload.id)
      } else {
        newStatusUpdate.delete(action.payload.id)
      }
      return {
        ...state,
        loading: {
          ...state.loading,
          statusUpdate: newStatusUpdate,
        },
      }
    }

    case ActionType.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case ActionType.SET_DATA: {
      const registration = action.payload?.detailed?.registration
      const divisions = action.payload?.detailed?.divisions
      // Extract currency from registration or use default
      const currency = registration?.currency || state.currency
      // Registration is empty if no starts_at date or no divisions
      const isRegistrationEmpty =
        !registration?.starts_at || divisions?.length === 0
      return {
        ...state,
        data: action.payload,
        isPlayerRegistrationEnabled:
          registration?.is_player_registration ?? false,
        isTeamRegistrationEnabled: registration?.is_team_registration ?? false,
        showWaiver: registration?.show_waiver ?? false,
        currency,
        isRegistrationEmpty,
      }
    }

    case ActionType.SET_ANALYTICS:
      return {
        ...state,
        analytics: action.payload,
      }

    case ActionType.SET_TYPES:
      return {
        ...state,
        types: action.payload,
      }

    case ActionType.SET_DIVISIONS:
      return {
        ...state,
        divisions: action.payload,
      }

    default:
      return state
  }
}
